/*
 * @Description:
 * @Date: 2021-11-05 17:58:33
 */
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      sanji_homeProject: state => state.homeProject
    })
  },
  data() {
    return {
      businessTypeAllObj: {},
      isIndustry: '',
      isP: ''
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(v) {
        const homeProject = this.sanji_homeProject;
        let name = v.path;
        if (homeProject && homeProject.businessType) {
          this.searchQuery.businessType = homeProject.businessType;
        } else {
          if (/Four/i.test(name)) {
            //四级汇总
            this.searchQuery.projectStructureType = 1;
            this.searchQuery.businessType = 1;
            this.isIndustry = true;
            this.isP = true;
          } else if (/ThreeTotal/i.test(name)) {
            //三级汇总
            this.searchQuery.projectStructureType = 1;
            this.searchQuery.businessType = 2;
            this.isIndustry = false;
            this.isP = true;
          } else if (/ThreeEntrusted/i.test(name)) {
            //三级代开
            this.searchQuery.projectStructureType = 3;
            this.searchQuery.businessType = 3;
            this.isIndustry = true;
            this.isP = false;
          } else if (/TwoEntrusted/i.test(name)) {
            //二级代开
            this.searchQuery.projectStructureType = 3;
            this.searchQuery.businessType = 4;
            this.isIndustry = false;
            this.isP = false;
          } else if (/TwoFlex/i.test(name)) {
            //二级灵工
            this.searchQuery.projectStructureType = 3;
            this.searchQuery.businessType = 6;
            this.isIndustry = false;
            this.isP = false;
          } else if (/ThreeCompany/i.test(name)) {
            //三级个体
            this.searchQuery.projectStructureType = 2;
            this.searchQuery.businessType = 7;
            this.isIndustry = true;
            this.isP = false;
          } else if (/TwoCompany/i.test(name)) {
            //二级个体
            this.searchQuery.projectStructureType = 2;
            this.searchQuery.businessType = 8;
            this.isIndustry = false;
            this.isP = false;
          } else if (/ThreeFlex/i.test(name)) {
            //三级灵工
            this.searchQuery.businessType = 5;
          } else if (/ThreePerson/i.test(name)) {
            //三级个人
            this.searchQuery.projectStructureType = 3;
          } else if (/ToolType/i.test(name)) {
            //工具
            this.searchQuery.businessType = 9;
          }
        }
        if (homeProject && homeProject.projectStructureType) {
          //在项目详情里自动混合项目类型
          this.searchQuery.projectStructureType =
            homeProject.projectStructureType;
          if (homeProject.projectStructureType != 1) {
            this.searchQuery.userType = 4 - homeProject.projectStructureType;
          } else {
            //四级跟三级个人一样 userType传1
            this.searchQuery.userType = 1;
          }
        }
      }
    }
  }
};
